export enum EBanner {
    desktop_top      = "div-dtop",
    desktop_skyleft  = "div-skyleft",
    desktop_skyright = "div-skyright",
    desktop_vertical1   = "div-dv1",
    desktop_vertical2   = "div-dv2",
    desktop_vertical3   = "div-dv3",
    desktop_vertical4   = "div-dv4",
    desktop_vertical5   = "div-dv5",
    desktop_horizontal1  = "div-dh1",
    desktop_horizontal2  = "div-dh2",
    desktop_horizontal3  = "div-dh3",
    desktop_horizontal4  = "div-dh4",
    desktop_horizontal5  = "div-dh5",
    desktop_galeria  = "g2_desktop",
    desktop_nativo   = "div-dnat",
    desktop_bottom   = "div-dbottom",

    mobile_top     = "div-mtop",
    mobile_center1 = "div-m1",
    mobile_center2 = "div-m2",
    mobile_center3 = "div-m3",
    mobile_center4 = "div-m4",
    mobile_center5 = "div-m5",
    mobile_center6 = "div-m6",
    mobile_center7 = "div-m7",
    mobile_center8 = "div-m8",
    mobile_center9 = "div-m9",
    mobile_center10 = "div-m10",
    mobile_sticky  = "div-sticky",
    mobile_nativo  = "div-mnat",
    mobile_bottom  = "div-mbottom",

    directo1 = 'div-directo1',
    directo2 = 'div-directo2',
    directo3 = 'div-directo3',
    directo4 = 'div-directo4',
    directo5 = 'div-directo5',

    galeria = "div-g1",
    galeria_mobile = "div-mg1",

    inimage = "div-inimage",

    helvetia_100 = "div-helvetia100",
    helvetia_250 = "div-helvetia250",
}
